import { Tag } from '@chakra-ui/react';
import { CONTENT_STATUS, CONTENT_STATUS_COLORS } from 'util/enumValues';

//const TAG_COLOR_SCHEMES = ['orange', 'pink', 'blue', 'purple', 'green', 'red'];

interface Email {
  status: 'DRAFT' | 'WAITING' | 'SENDING' | 'SENT'
}

interface ContentDelivery {
  email?: Email;
  isOnlyNewsletter?: boolean;
  composesNewsletter?: boolean;
}

interface TagEmailStatusProps {
  record: ContentDelivery
}

export function StatusFromContentDelivery(contentDelivery: ContentDelivery) {
  let status = contentDelivery.email?.status || 'DRAFT';

  if (contentDelivery.isOnlyNewsletter && contentDelivery.composesNewsletter)
    status = 'SENT'; 
  return status;
}

export default function TagEmailStatus({ record }: TagEmailStatusProps ) {
  const status = StatusFromContentDelivery(record);

  return (
    <Tag 
      flexShrink={0}
      size="sm"
      colorScheme={CONTENT_STATUS_COLORS[status]}
    >
      {CONTENT_STATUS[status]}
    </Tag>
  )
}